<script>
import * as constants from '@/utilities/appConsts'

export default {
  props: {
    size: {
      type: String,
      default: constants.FONT_SIZES.md,
      validator: val =>
        [
          constants.FONT_SIZES.xs,
          constants.FONT_SIZES.sm,
          constants.FONT_SIZES.md,
          constants.FONT_SIZES.lg,
          constants.FONT_SIZES.xl,
          constants.FONT_SIZES.xxl,
          constants.FONT_SIZES.xxxl,
          constants.FONT_SIZES.xxxxl,
        ].includes(val),
    },
  },
}
</script>
